const keys = {
  all: ['insuranceRequests'],
  insuranceRequest: id => [...keys.all, { insuranceRequestId: id }],
  insuranceRequestInsured: id => [...keys.all, 'insuranceRequestInsured', { insuranceRequestId: id }],
  agencies: id => [...keys.insuranceRequest(id), 'agencies']
};

export default keys;
